<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2" [innerHTML]="'HOLD_ON' | translate"></h1>
  <p class="mb-0">
    {{ 'DO_YOU_WISH_TO_REMOVE_YOUR_EXISTING_VIDEO_CALL' | translate }}
  </p>
</app-modal-body>
<app-modal-footer classList="d-flex  justify-content-center">
  <button
    class="btn btn-primary rounded-5"
    (click)="cancelVideoMeeting()"
    [disabled]="activeButton === ActiveButton.CANCEL_VIDEO_MEETING && isHttpRequestRunning"
  >
    @if (activeButton === ActiveButton.CANCEL_VIDEO_MEETING && isHttpRequestRunning) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    }
    {{ 'YES_DELETE' | translate }}
  </button>

  <button
    class="btn rounded-5"
    (click)="close()"
    [class.btn-outline-dark]="!isBgDarkMode"
    [class.btn-outline-light]="isBgDarkMode"
  >
    {{ 'NO_GO_BACK' | translate }}
  </button>
</app-modal-footer>
